/**
 * @author       justin.jeong@zumper.com (Justin Jeong)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  FlaggedIds constants
 */

// Set Flagged Entities
export const FLAG_BUILDING = '@@nzr/flaggedIds/FLAG_BUILDING'
export const FLAG_LISTING = '@@nzr/flaggedIds/FLAG_LISTING'
